












































import Component from 'vue-class-component'
import { Emit, Vue, Watch } from 'vue-property-decorator'
import Country from '@/dto/deliveries/Country'
import LocationService from '@/services/LocationService'
import AsyncSelect from '@/components/shipment/form/AsyncSelect.vue'
import Place from '@/dto/deliveries/Place'
import Region from '@/dto/deliveries/Region'
import shipmentStore from '@/stores/ShipmentStore'
import ShipmentPoint from '@/dto/deliveries/ShipmentPoint'
import { Routes } from '@/router/routes'
@Component({
  components: { AsyncSelect },
})
export default class ShipmentForm extends Vue {
  shipmentStore = shipmentStore
  countryId: number | null = null
  regionId: number | null = null
  placeId: number | null = null
  countriesOptions: any[] = []
  regionsOptions: any[] = []
  placesOptions: any[] = []

  isPending: boolean = false
  errorMessage: string = ''

  get isDisableButton() {
    return [this.countryId, this.regionId, this.placeId].some(
      value => value === null
    )
  }

  saveShipmentPoint() {
    this.isPending = true
    this.shipmentStore
      .saveShipmentPoint({
        countryId: this.countryId as number,
        regionId: this.regionId as number,
        placeId: this.placeId as number,
      })
      .then((shipmentPoint: ShipmentPoint) => {
        this.$emit('saved')
        this.$router.push({
          name: Routes.deliveries,
          params: { shipmentPointId: shipmentPoint.id.toString() },
        })
      })
      .catch((errorText: string) => {
        this.errorMessage = errorText
      })
      .finally(() => (this.isPending = false))
  }

  filterCountries(query: string, update: Function, abort: Function) {
    if (query.length === 0) {
      abort()
      return
    }

    LocationService.getCountries().then((countries: Country[]) => {
      update(() => {
        this.countriesOptions = countries
          .filter(
            (country: Country) =>
              country.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
          )
          .map((country: Country) => ({
            label: country.name,
            value: country.id,
          }))
      })
    })
  }

  filterRegions(query: string, update: Function, abort: Function) {
    if (query.length === 0) {
      abort()
      return
    }

    LocationService.getRegions(this.countryId as number, query).then(
      (countries: Region[]) => {
        update(() => {
          this.regionsOptions = countries
            .filter(
              (region: Region) =>
                region.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
            )
            .map((region: Region) => ({
              label: region.name,
              value: region.id,
            }))
        })
      }
    )
  }

  filterPlaces(query: string, update: Function, abort: Function) {
    if (query.length === 0) {
      abort()
      return
    }

    LocationService.getPlacesForRegion(this.regionId as number, query).then(
      (places: Place[]) => {
        update(() => {
          this.placesOptions = places
            .filter(
              (place: Place) =>
                place.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
            )
            .map((place: Place) => ({
              label: place.name,
              value: place.id,
            }))
        })
      }
    )
  }

  @Watch('countryId')
  resetRegion() {
    this.regionId = null
  }

  @Watch('regionId')
  resetPlace() {
    this.placeId = null
  }

  @Watch('placeId')
  resetErrors() {
    this.errorMessage = ''
  }
}
